module.exports = __webpack_public_path__ + "img/Rotor_Course_Gauge_Plate_v01.ee9b117c.svg";